import { render, staticRenderFns } from "./MduiSpinner.vue?vue&type=template&id=15f2ef8e"
import script from "./MduiSpinner.vue?vue&type=script&lang=js"
export * from "./MduiSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports